import type { ThemeProps } from "models/styles/theme";
import { css } from "styled-components/macro";

export const errorInputCss = css`
  border: 1px solid;
  border-color: ${({ theme }: ThemeProps) => theme.palette.feedback.error.brand};
  background-color: ${({ theme }: ThemeProps) => theme.palette.feedback.error._950};
`;
